



















































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "btn-default"
})
export default class BtnDefault extends Vue {
  @Prop({type: [String], default: ''}) protected text!: string
  @Prop({type: [String , Boolean], default: false}) protected icon!: string | boolean
  @Prop({type: Boolean, default: false}) protected response!: boolean
  @Prop({type: Boolean, default: false}) protected disabled!: boolean
  @Prop({type: Boolean, default: false}) protected loading!: boolean
  @Prop({type: [Number, String], default: 0}) protected count!: number | string
  @Prop({type: String, default: '#2C9CDB'}) protected color!: string
  @Prop({type: String, default: 'auto'}) protected width!: string
  @Prop({type: String, default: '36px'}) protected height!: string
  @Prop({type: Boolean, default: false}) protected fullWidth!: boolean
  @Prop({type: Boolean, default: false}) protected isWhite!: boolean
  @Prop({type: Boolean, default: false}) protected isRed!: boolean
  @Prop({type: Boolean, default: false}) protected isTransparent!: boolean
  @Prop({type: String, default: undefined}) protected href!: boolean
  @Prop({type: String, default: undefined}) protected target!: boolean

  click() {
    this.$emit('clickbtn')
  }

}
